import { getStaticGoogleMapUri } from 'shared/components/StaticGoogleMap/utils/getStaticGoogleMapUri';

import {
    StaticGoogleMapProps,
    ResponsiveImage
} from '../StaticGoogleMap.types';

const useStaticGoogleMapURL = (
    props: StaticGoogleMapProps
): ResponsiveImage[] => {
    const { mapSizes, responsiveSizes, ...restOfProps } = props;
    const googleMapImageUrls: ResponsiveImage[] = [];

    // We generate two map image URLs for each size requested - a standard resolution
    // version (scale=1) and a 2x resolution (i.e. retina) image (scale=2)
    mapSizes.forEach(([width, height]) => {
        // standard non-retina
        googleMapImageUrls.push({
            width: width,
            src: getStaticGoogleMapUri({
                width,
                height,
                scale: 1,
                ...restOfProps
            })
        });

        // retina (double pixel width)
        googleMapImageUrls.push({
            width: width * 2,
            src: getStaticGoogleMapUri({
                width,
                height,
                scale: 2,
                ...restOfProps
            })
        });
    });

    return googleMapImageUrls;
};

export default useStaticGoogleMapURL;
